import { C, STEPS } from "../utils/tokens";

const isStepValid = (step, info, esperienze, formazione) => {
  if (step === 1) {
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(info.email || "");
    return !!(
      info.nome?.trim().length >= 2 &&
      info.cognome?.trim().length >= 2 &&
      emailOk
    );
  }
  if (step === 2)
    return esperienze.some((e) => e.azienda?.trim() && e.ruolo?.trim());
  if (step === 3)
    return formazione.some((e) => e.istituto?.trim() && e.titolo?.trim());
  return true;
};

const StepNavBar = ({
  step,
  tpl,
  info,
  esperienze,
  formazione,
  onBack,
  onNext,
}) => {
  const acc = tpl?.color || C.gold;
  const valid = isStepValid(step, info, esperienze, formazione);
  const isLast = step >= STEPS.length;
  const nextLabel = STEPS[step]?.label || "";

  return (
    <>
      <style>{`
        @keyframes navPulse {
          0%,100% { box-shadow: 0 0 0 0 ${acc}44; }
          50% { box-shadow: 0 0 0 8px ${acc}00; }
        }
        @keyframes shake {
          0%,100% { transform: translateX(0); }
          20% { transform: translateX(-6px); }
          40% { transform: translateX(6px); }
          60% { transform: translateX(-4px); }
          80% { transform: translateX(4px); }
        }
        .nav-bar-btn-next {
          transition: all 0.25s cubic-bezier(0.34,1.56,0.64,1);
        }
        .nav-bar-btn-next:hover:not(:disabled) {
          transform: scale(1.02) translateY(-1px);
        }
        .nav-bar-btn-next:active:not(:disabled) {
          transform: scale(0.98);
        }
        .nav-bar-btn-back {
          transition: all 0.2s ease;
        }
        .nav-bar-btn-back:hover {
          background: rgba(255,255,255,0.03) !important;
        }

        /* ── RESPONSIVE COMPACT ENGINE ── */
        .step-navbar-fixed {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 200;
          background: rgba(8,9,9,0.94);
          backdrop-filter: blur(32px);
          -webkit-backdrop-filter: blur(32px);
          padding: 0 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 76px;
          gap: 16px;
        }

        .navbar-dots-center {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        @media (max-width: 768px) {
          .step-navbar-fixed {
            padding: 0 16px !important;
            height: 72px !important;
            gap: 10px !important;
          }
          
          /* Nascondiamo i pallini centrali su mobile per evitare sovrapposizioni con i bottoni */
          .navbar-dots-center {
            display: none !important;
          }

          /* Il tasto indietro diventa più compatto lasciando spazio all'azione principale */
          .nav-bar-btn-back {
            padding: 10px 14px !important;
            flex-shrink: 0;
          }
          .nav-bar-btn-back span:last-child {
            display: none; /* Nasconde "Template" o "Indietro" lasciando solo la freccia */
          }

          /* Il pulsante avanti prende tutto lo spazio rimanente in modo fluido */
          .nav-bar-btn-next {
            flex: 1 !important;
            min-width: 0 !important;
            padding: 12px 16px !important;
          }

          .next-btn-text-main {
            font-size: 13px !important;
          }

          .next-btn-text-sub {
            display: none !important; /* Nasconde il micro-testo del nome dello step successivo per pulizia */
          }
        }
      `}</style>

      <div
        className="step-navbar-fixed"
        style={{
          borderTop: `1px solid ${valid ? acc + "33" : C.border}`,
          transition: "border-color 0.4s ease",
          boxShadow: valid ? `0 -8px 40px ${acc}12` : "none",
        }}
      >
        {/* Pulsante Indietro / Back */}
        <button
          className="nav-bar-btn-back"
          onClick={onBack}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            background: "none",
            border: `1px solid ${C.border}`,
            borderRadius: 12,
            padding: "12px 20px",
            color: C.muted,
            fontSize: 13,
            fontFamily: "'Syne',sans-serif",
            fontWeight: 600,
            cursor: "pointer",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.borderColor = C.borderHover)
          }
          onMouseLeave={(e) => (e.currentTarget.style.borderColor = C.border)}
        >
          <span style={{ fontSize: 15, lineHeight: 1 }}>←</span>
          <span>{step === 1 ? "Template" : "Indietro"}</span>
        </button>

        {/* Indicatori a Pallini (Solo Desktop) */}
        <div className="navbar-dots-center">
          {STEPS.map((s) => (
            <div
              key={s.id}
              style={{
                width: step > s.id ? 16 : step === s.id ? 24 : 6,
                height: 6,
                borderRadius: 3,
                background: step > s.id ? acc : step === s.id ? acc : C.border,
                opacity: step > s.id ? 0.4 : 1,
                transition: "all 0.4s cubic-bezier(0.34,1.56,0.64,1)",
              }}
            />
          ))}
        </div>

        {/* Pulsante Avanti / Next */}
        {!isLast ? (
          <button
            className="nav-bar-btn-next"
            onClick={
              valid
                ? onNext
                : (e) => {
                    e.currentTarget.style.animation = "shake 0.4s ease";
                    setTimeout(() => {
                      if (e.currentTarget) e.currentTarget.style.animation = "";
                    }, 400);
                  }
            }
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              background: valid
                ? `linear-gradient(135deg, ${acc}, ${acc}cc)`
                : "rgba(255,255,255,0.04)",
              border: valid ? "none" : `1px solid ${C.border}`,
              borderRadius: 12,
              padding: "12px 28px",
              color: valid ? "#050505" : C.muted,
              fontFamily: "'Syne',sans-serif",
              fontWeight: 800,
              cursor: valid ? "pointer" : "not-allowed",
              animation: valid ? "navPulse 3s infinite" : "none",
              minWidth: 170,
            }}
          >
            {valid ? (
              <>
                <span className="next-btn-text-main" style={{ fontSize: 14 }}>
                  Continua
                </span>
                <span
                  className="next-btn-text-sub"
                  style={{
                    opacity: 0.7,
                    fontSize: 11,
                    fontWeight: 500,
                    marginLeft: 2,
                  }}
                >
                  ({nextLabel})
                </span>
                <span style={{ fontSize: 15, lineHeight: 1 }}>→</span>
              </>
            ) : (
              <>
                <span style={{ fontSize: 13 }}>🔒</span>
                <span className="next-btn-text-main" style={{ fontSize: 13 }}>
                  Compila i campi
                </span>
              </>
            )}
          </button>
        ) : (
          /* Placeholder simmetrico nel caso dell'ultimo step su desktop */
          <div className="navbar-dots-center" style={{ width: 44 }} />
        )}
      </div>
    </>
  );
};

export default StepNavBar;
